export default function () {
  const widgetName = 'cardsSecondFeature';
  const widgetOpts = cardsSecondFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customizeWidget() {
        let nmbrSlides = 1;
        $(`#${widgetName} .card-widget-item`).each(function () {

          $(this).find('.image-container').prepend('<div class="overlay-card"></div>')

          $(this).each(function () {
            $(this).addClass(`index-${nmbrSlides}`)
          })
          nmbrSlides++;

          let title = $(this).find('.card-widget-title').text()
          let moreButton = $(this).find('.moreButton').attr('href')
          let buyButton = $(this).find('.buyNowButton').attr('href')

          $(this).find('.image-container').append(`<div class="title-overlay">${title}</div>`)
          $(this).find('.image-container').append(`<a class="button cardBtn" href="${buyButton}">Buy Now!</a>`)
          $(this).find('.image-container').append(`<a class="moreLink" href="${moreButton}">More</a>`)

          !moreButton && $(this).find('.moreLink').remove()
          !buyButton && $(this).find('.cardBtn').remove()
        })
      }

      let qCards = slide.items.length

      if (qCards >= 1) {
        $('#cardsSecondFeature').addClass('addTitle')
        $('.cards-container').css('padding', "6rem 0 3rem 0")
      }
      customizeWidget()
    },
    buyNowButton: {
      visible: true,
      text: 'BUY NOW!'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });
}